// extracted by mini-css-extract-plugin
module.exports = {"nav-brand":"NavBrand_nav-brand__3MNTi"};